import { GMiniSwitch } from '@pharmsnap/shared/components/ui/GMiniSwitch/GMiniSwitch'
import { GTooltip } from '@pharmsnap/shared/components/ui/GTooltip/GTooltip'
import { E_NODATA_SIZE } from '@pharmsnap/shared/src/types'
import { defineComponent, unref } from '@vue/composition-api'
import { GEmpty } from '../../../ui/GEmpty/GEmpty'
import { GLoading } from '../../../ui/GLoading/GLoading'
import { useInjectFilterService } from '../compositions/useProvideFilterService'
import cn from '../locales/cn.json'
import en from '../locales/en.json'
import jp from '../locales/jp.json'
import tw from '../locales/tw.json'
import { IFilterItemListRollupData, IFilterItemStateTreeNodeNext } from '../type'
import { getRealSimpleText } from '../utils'
import { BFilterAdvanceUiTypeRadio } from './BFilterAdvanceUiTypeRadio'

export const BFilterAdvanceContentPanel = defineComponent({
  name: 'BFilterAdvanceContentPanel',
  i18n: {
    messages: {
      cn,
      en,
      jp,
      tw,
    },
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    isEmpty: {
      type: Boolean,
      default: false,
    },
    emptyText: {
      type: String,
      default: '',
    },
  },
  setup() {
    return useInjectFilterService()
  },
  methods: {
    renderUiTypeRadio() {
      const advanceUiState = unref(this.filterService.selectedState) as IFilterItemStateTreeNodeNext | undefined

      if (!advanceUiState?.identity) return null

      if (advanceUiState._advance.uiTypes.length <= 1) return null

      return [
        <span class="ml-auto mr-2 text-sm text-text-t2">{this.$t('bFilterNext.orderBy')}:</span>,
        <BFilterAdvanceUiTypeRadio></BFilterAdvanceUiTypeRadio>,
      ]
    },
    renderRollup() {
      const advanceUiState = unref(this.filterService.selectedState) as IFilterItemStateTreeNodeNext | undefined
      if (!advanceUiState?.identity) return null

      const { _meta, _advance, data } = advanceUiState
      const { originLayoutConfig, originAggFieldConfig } = _meta
      const uiType = originLayoutConfig.uiAggField.uiType
      const fieldType = originAggFieldConfig.type

      const activeUiType = _advance.activeUiType

      const dataDetail = data?.[activeUiType]

      if (!dataDetail) return null

      if (uiType === 'checkbox-rollup' && fieldType === 'switch') {
        const { rollup, rollupTriggerText, rollupTriggerTooltip } = dataDetail as IFilterItemListRollupData
        const renderTooltip = (content: JSX.Element) => {
          return (
            <GTooltip style="line-height:0; font-size:0;" theme="light" content={getRealSimpleText(rollupTriggerTooltip || '', unref(this.locale))}>
              {content}
            </GTooltip>
          )
        }

        const content = (
          <GMiniSwitch
            disabled={this.isLoading}
            value={rollup}
            onChange={() => this.filterService.changeRollUp(activeUiType)}
            width={16}
            active-color="#1976D2"
            inactive-color="#BCC2CC"
            active-text={getRealSimpleText(rollupTriggerText || '', unref(this.locale))}
          ></GMiniSwitch>
        )

        return <div class="ml-auto">{rollupTriggerTooltip ? renderTooltip(content) : content}</div>
      }

      return null
    },
    renderContent() {
      if (this.isLoading) {
        return (
          <div class="relative h-full">
            <GLoading></GLoading>
          </div>
        )
      }

      return [
        <div v-show={this.isEmpty} class="h-full flex items-center justify-center">
          <GEmpty size={E_NODATA_SIZE.SMALL} title={this.emptyText}></GEmpty>
        </div>,
        <div v-show={!this.isEmpty} class="h-full">
          {this.$slots.default}
        </div>,
      ]
    },
    renderTop() {
      // 如何this.$slots.topLeft和renderUiTypeRadio都为null，不渲染
      const nodes = [this.$slots.topLeft, this.renderUiTypeRadio(), this.renderRollup()]
      if (nodes.every((node) => !node)) return null

      return <div class="flex-shrink-0 flex items-center h-10">{nodes}</div>
    },
  },
  render() {
    return (
      <div class={['flex flex-col']}>
        {this.renderTop()}
        <div class="mt-2 rounded border border-gray-40 flex-1 overflow-hidden p-2">{this.renderContent()}</div>
      </div>
    )
  },
})
